import VpnKeyOutlinedIcon from '@mui/icons-material/VpnKeyOutlined';
import AccessAnalyzerDetailBody from '../AccessAnalyzerDetailBody';

// Descriptor for the IAM Access Analyzer engine - the 6th detection engine and
// the 7th Security Hub capability (AWS Config is a capability but deliberately
// not an engine, so the two counts differ by one). Same shape as cspm.js /
// guardduty.js / macie.js / inspector.js / detective.js; registering it in
// registry.js auto-wires the sidebar, Overview tiles, the EnableCapabilities
// panel, Configuration → Regions and the unified findings inbox.
export const accessAnalyzerEngine = {
  id: 'accessanalyzer', // MUST equal the backend Engine.ID()
  label: 'IAM Access Analyzer',
  // Deep raspberry. The five accents already in use - CSPM sky blue #4698D3,
  // GuardDuty orange #E65100, Macie teal #0d9488, Inspector purple #7D3C98,
  // Detective indigo #3949AB - leave the blue/teal/indigo band fully occupied,
  // and the six tiles are compared SIDE BY SIDE in the Overview and
  // EnableCapabilities grids, so a second blue-family accent would read as a
  // shade of an existing engine rather than as its own. This hue is ~50° clear
  // of every one of them, and it echoes AWS's own Security-Identity-Compliance
  // category colour, which suits an IAM service.
  //
  // It is also kept clear of the severity palette in severity.js: CRITICAL
  // #E74C3C is a far lighter, more orange red (hue ~6°, L 58% vs this one's
  // ~335°, L 38%), so an engine badge can never be mistaken for a severity chip.
  // Green was excluded outright - #27AE60 is the portal's "healthy" status
  // colour in portalStyles.js and would mean the wrong thing on a findings tile.
  //
  // The hex is duplicated as a local const in every Access Analyzer page; that
  // duplication is the established convention here, not an oversight.
  color: '#AD1457',
  // A key, not another shield: SecurityIcon (CSPM) and GppMaybeIcon (GuardDuty)
  // are both shields, and at 28px in the tile grid a third would be hard to tell
  // from them. The key silhouette is unique in this set and says what the engine
  // answers - who outside this account holds access to the resource, and which
  // granted access is never used.
  Icon: VpnKeyOutlinedIcon,
  // NOTE: the card's copy (name/source/description/items) is served by the
  // BACKEND - EnableCapabilities reads `row.capability` from /capabilities and
  // falls back to `{}`, never to this file. A duplicate here was already drifting
  // from Go's Capability() on at least one engine, so it was removed rather than
  // left to be trusted. Change the copy in securityhub_engine_<id>.go.
  // Sidebar sub-items. They hang directly off the SECURITY HUB group -
  // there is no "Detection engines" grouping in PortalSidebar.
  // Routes are NOT generated from this list - every entry needs a matching
  // <Route> in App.js or it falls through to the catch-all redirect, which looks
  // like the page does not exist rather than like a missing route.
  nav: [
    { label: 'Dashboard', to: '/securityhub/accessanalyzer' },
    { label: 'Findings', to: '/securityhub/accessanalyzer/findings' },
    { label: 'Enrollment', to: '/securityhub/accessanalyzer/enrollment' },
    { label: 'Settings', to: '/securityhub/accessanalyzer/settings' },
  ],
  enableRoute: '/securityhub/accessanalyzer', // where "Enable/Configure" routes
  DetailBody: AccessAnalyzerDetailBody,
};
